const API_GROWING_FAMILY_FIELDS = [
    'growing_family_section.image',
    'growing_family_section.translations.title',
    'growing_family_section.translations.text'
];
const API_LIBRARY_WIDGET_FIELDS = [
    'library_widget.image',
    'library_widget.translations.title',
    'library_widget.translations.small_title',
    'library_widget.translations.link'
];
const API_NEWSLETTER_FIELDS = [
    'newsletter_section.translations.section_title',
    'newsletter_section.translations.name_field',
    'newsletter_section.translations.email_field',
    'newsletter_section.translations.button_label',
    'newsletter_section.translations.button_link'
];
const API_PARTNER_SECTION_FIELDS = [
    'partner_section.translations.title',
    'partner_section.partners.partner_id.image',
    'partner_section.partners.partner_id.is_country',
    'partner_section.partners.partner_id.translations.name'
];
const API_FOOTER_SECTION_FIELDS = [
    'footer_section.translations.copyright_text',
    'footer_section.translations.address',
    'footer_section.translations.postal_code',
    'footer_section.translations.contacts',
    'footer_section.translations.email',
    'footer_section.footer_menu.menus_id.translations.name',
    'footer_section.footer_menu.menus_id.translations.link'
];
export { API_GROWING_FAMILY_FIELDS, API_LIBRARY_WIDGET_FIELDS, API_NEWSLETTER_FIELDS, API_PARTNER_SECTION_FIELDS, API_FOOTER_SECTION_FIELDS };
